import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';

const ANTIBODY_BETA_FEEDBACK_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLScNEUhMYT1rA7wcXGPutNV9uBdFYB1lJ8rGiEGiqBPoHiN1Gw/viewform';

/**
 * Render a banner for soliciting beta feedback for the antibody feature.
 */
export default function AntibodyFeedbackBanner(): JSX.Element {
  if (BenchlingConfig.MOLBIO_HIDE_ANTIBODY_FEEDBACK_BANNER) {
    return <></>;
  }
  return (
    <InlineBanner
      bannerType={InlineBannerType.BETA}
      hideIcon={true}
      text={
        <>
          Antibodies are a new beta feature.{' '}
          <a href={ANTIBODY_BETA_FEEDBACK_FORM} target="_blank" rel="noreferrer">
            Share your feedback to help us improve
          </a>
          .
        </>
      }
    />
  );
}
